import FileUploaderV2List from '@core/components/ApplyDialogV2/FileUploaderV2List'
import React from 'react'
import './ApplyV2ReviewApplyCv.scss'

interface ApplyV2ReviewApplyCv {
    className?: string
}

const baseClass = 'ApplyV2ReviewApplyCv'

function ApplyV2ReviewApplyCv({ className = '' }: ApplyV2ReviewApplyCv) {
    return (
        <div className={`${baseClass} ${className}`}>
            <FileUploaderV2List files={[]} isShowDelete={false} isShowParseInfo={false}></FileUploaderV2List>
        </div>
    )
}

export default ApplyV2ReviewApplyCv
